export default function CompletedPage() {
  return (
    <div className='flex h-dvh w-full flex-col items-center justify-center'>
      <div className='flex size-full flex-col items-center justify-center gap-4 p-4'>
        <img src='id_front_passed.png' alt='face verification success icon' />
        <div className='flex flex-col items-center justify-center gap-2'>
          <h5 className='text-text-primary mt-4 font-semibold'>รับคำร้องยืนยันตัวตนเรียบร้อย</h5>
          <div className='text-body-1 text-text-secondary text-center'>
            ระบบกำลังตรวจสอบข้อมูล <br />
            โดยจะส่งผลการยืนยันตัวตนผ่านทางอีเมล <br />
            อาจใช้เวลาในการตรวจสอบ 3-7 วันทำการ
          </div>
        </div>
      </div>
    </div>
  );
}
